<ion-header>
    <ion-toolbar>
        <ion-title>
            @if (!isEdit) { 
                {{ 'Create Match' | translate }} 
            } @else { 
                {{ 'Edit Match' | translate }} 
            }
        </ion-title>
        <ion-buttons slot="end">
            <ion-button (click)="close()">
                <ion-icon slot="end" name="close"></ion-icon>
            </ion-button>
        </ion-buttons>
    </ion-toolbar>
</ion-header>

<ion-content>
    @if (formActive && form?.value) {
        <form [formGroup]="form">
            <ion-list>
                <ion-item [hidden]="isEdit">
                    <ion-select label="{{ 'Sport' | translate }}" label-placement="stacked" value="TENNIS" placeholder="Select sport" interface="popover" formControlName="discipline">
                        <ion-select-option value="TENNIS">Tennis</ion-select-option>
                        <ion-select-option value="PADEL">Padel</ion-select-option>
                        <ion-select-option value="PICKLEBALL">Pickleball</ion-select-option>    
                        @if(authService.authUserSignal()?.role?.value > 399) {                    
                            <ion-select-option value="BADMINTON">Badminton</ion-select-option>
                            <ion-select-option value="TABLE_TENNIS">Table Tennis</ion-select-option>
                            <ion-select-option value="SQUASH">Squash</ion-select-option>
                        }
                    </ion-select>
                </ion-item>

                @if (tournament) {
                    <!-- Schedule match -->
                    <app-datetime-item
                        formControlName="startDate"
                        [min]="tournament?.startDate"
                        [max]="tournament?.endDate"
                        [presentation]="'date-time'"
                        [minuteValues]="'0, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55'"
                        [preferWheel]="true"
                        [label]="'Start time' | translate">
                    </app-datetime-item>

                    <!-- Round name -->
                    <app-round-name [match]="match" (roundName)="setRoundName($event)"></app-round-name>
                }

                <!-- Match Type -->
                @if (!isEdit) {
                    <ion-item [hidden]="tie">
                        <ion-select label="{{ 'Singles' | translate }} / {{ 'Doubles' | translate }}" label-placement="stacked" interface="popover" value="S" formControlName="matchType">
                            <ion-select-option value="S">{{ 'Singles' | translate }} </ion-select-option>
                            <ion-select-option value="D">{{ 'Doubles' | translate }} </ion-select-option>
                        </ion-select>
                    </ion-item>
                }


                <ion-item-divider color="light">
                    <ion-label>{{ 'Select players' | translate }}</ion-label>
                </ion-item-divider>

                <!-- Participant 1 -->
                <ion-item button (click)="!side1Player?.length ? addPlayer(1) : clearParticipant(1)">
                    <ion-label>{{side1Player || participantLabel + ' 1' }}</ion-label>
                    <ion-button color="dark" [hidden]="!side1Player" slot="end" fill="clear">
                        <ion-icon slot="icon-only" name="close"></ion-icon>
                    </ion-button>
                </ion-item>

                <!-- Participant 2 -->
                <ion-item button (click)="!side2Player?.length ? addPlayer(2) : clearParticipant(2)">
                    <ion-label>{{side2Player || participantLabel + ' 2' }}</ion-label>
                    <ion-button color="dark" [hidden]="!side2Player" slot="end" fill="clear">
                        <ion-icon slot="icon-only" name="close"></ion-icon>
                    </ion-button>
                </ion-item>
                @if(!this.isEdit && isIndividualPalge && this.authService.authUserSignal()?.role?.value > 399){
                    <ion-item-divider color="light">
                        <ion-label>{{ 'Select policy' | translate }}</ion-label>
                    </ion-item-divider>

                    <ion-item>
                        <ion-select label="{{ 'Policy' | translate }}" interface="popover" placeholder="{{ 'Select policy' | translate }}" formControlName="policy" (ionChange)="onPolicySelected($event)">
                          @for (p of policyList; track $index;) {
                            <ion-select-option [value]="p._id">{{ p.name }}</ion-select-option>
                          }
                        </ion-select>
                    </ion-item>
                }
                @if (form.get('discipline').value === 'TENNIS' || form.get('discipline').value === 'PADEL') {
                    <app-match-format-form [matchFormat]="matchFormat" [setsLength]="match?.sets?.length" (updatedMatchFormat)="updateCollectionMatchFormat($event)" [dividerTitle]="'Score format'"></app-match-format-form>
                } @else if (form.get('discipline').value === 'PICKLEBALL') {
                    <app-pickleball-match-format-form [matchFormat]="matchFormat" [setsLength]="match?.sets?.length" (updatedMatchFormat)="updateCollectionMatchFormat($event)"></app-pickleball-match-format-form>
                } @else if (form.get('discipline').value === 'BADMINTON') {
                    <app-badminton-match-format-form [matchFormat]="matchFormat" [setsLength]="match?.sets?.length" (updatedMatchFormat)="updateCollectionMatchFormat($event)" [dividerTitle]="'Score format'"></app-badminton-match-format-form>
                } @else if (form.get('discipline').value === 'TABLE_TENNIS') {
                    <app-table-tennis-match-format-form [matchFormat]="matchFormat" [setsLength]="match?.sets?.length" (updatedMatchFormat)="updateCollectionMatchFormat($event)" [dividerTitle]="'Score format'"></app-table-tennis-match-format-form>
                } @else if (form.get('discipline').value === 'SQUASH') {
                    <app-squash-match-format-form [matchFormat]="matchFormat" [setsLength]="match?.sets?.length" (updatedMatchFormat)="updateCollectionMatchFormat($event)" [dividerTitle]="'Score format'"></app-squash-match-format-form>
                }

                <!-- Details -->
                <ion-item-divider color="light">
                    <ion-label>{{ 'Details' | translate }}</ion-label>
                </ion-item-divider>
                <ion-row>

                    <!-- Surface -->
                    <ion-col size="6">
                        <ion-item lines="none">
                            <ion-select label="{{ 'Surface' | translate }}" label-placement="stacked" interface="popover" placeholder="Select surface" formControlName="surfaceCategory">
                                <ion-select-option value="CLAY"> {{ 'Clay' | translate }}</ion-select-option>
                                <ion-select-option value="HARD">{{ 'Hard' | translate }}</ion-select-option>
                                <ion-select-option value="GRASS">{{ 'Grass' | translate }}</ion-select-option>
                                <ion-select-option value="CARPET">{{ 'Carpet' | translate }}</ion-select-option>
                            </ion-select>
                        </ion-item>
                    </ion-col>

                    <!-- Indoor / Outdoor -->
                    <ion-col size="6">
                        <ion-item lines="none">
                            <ion-select label="{{ 'Indoor' | translate }} / {{ 'Outdoor' | translate }}" label-placement="stacked" interface="popover" placeholder="Select facility type" formControlName="indoorOutdoor">
                                <ion-select-option value="OUTDOOR">{{ 'Outdoor' | translate }}</ion-select-option>
                                <ion-select-option value="INDOOR">{{ 'Indoor' | translate }}</ion-select-option>
                            </ion-select>
                        </ion-item>
                    </ion-col>
                </ion-row>
            </ion-list>

        </form>
    }
</ion-content>

<ion-footer>
    <ion-toolbar>
        <ion-button class="ion-margin" expand="full" type="submit" (click)="onSubmit(form.value)" [disabled]="isLoading">
            @if (!isLoading) {
                @if (!isEdit) { {{ 'Create Match' | translate }} }
                @else { {{ 'Save' | translate }} }
            } @else {
                <ion-spinner name="circular"></ion-spinner>
            }
        </ion-button>
    </ion-toolbar>
</ion-footer>